module.exports = __webpack_public_path__ + "img/alarm.60473323.svg";